import Api from "./axios-instance";
import {
  locationMockedData,
  serviceDetailMockedData,
  serviceListMockedData,
  areaZipcodeListMockedData
} from "./mock-data";
import { mockServiceCompleteReferralData } from '../components/screener/data/mockScreenerData';
import { isLocal } from "./helpers";
// import { mockSearchResponse } from "./mock-data";

// import { setSession } from "./set-session"

// import authService from "./auth.service";

export class SocialService {
  isJsonParsable(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  setSessionStorage(dataName, data) {
    try {
      sessionStorage.setItem(dataName, JSON.stringify(data));
    } catch (error) {
      console.warn(
        "sessionStorage.setItem failed. Delete session storage. Error: " + error
      );
      sessionStorage.clear();
      sessionStorage.setItem(dataName, JSON.stringify(data));
    }
  }

  async GetLocationById(locId, region, baseUrl) {
    Api.defaults.withCredentials = true;
    const dataName = `location-${locId}`;
    let sessionData = sessionStorage.getItem(dataName);
    if (sessionData && this.isJsonParsable(sessionData)) {
      return JSON.parse(sessionData);
    }

    // if script is run locally use mocked data
    if (isLocal()) {
      this.setSessionStorage(dataName, locationMockedData);
      return locationMockedData;
    } else {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      if (region) {
        headers["x-region"] = region;
      }

      if (baseUrl) {
        headers["x-provenance-info"] = baseUrl;
      }

      const cookiesArrayFromSession = JSON.parse(localStorage.getItem(`${window.location.host}`));
      if (cookiesArrayFromSession) {
        headers.Authorization = cookiesArrayFromSession?.join(';');
      }

      const encodedURL = encodeURI(
        `${process.env.VUE_APP_V1DIR}proxy/v1/locations/${locId}`
      );
      const response = await Api.get(encodedURL, { headers });
      this.setSessionStorage(dataName, response.data);
      return response.data;
    }
  }

  async GetServicesByTaxTerm_dep(taxTerm, zipcode, region, baseUrl) {
    Api.defaults.withCredentials = true;
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    if (baseUrl) {
      headers["x-provenance-info"] = baseUrl;
    }

    const cookiesArrayFromSession = JSON.parse(localStorage.getItem(`${window.location.host}`));
    if (cookiesArrayFromSession) {
      headers.Authorization = cookiesArrayFromSession?.join(';');
    }

    // zipcode = "49058";
    // taxTerm = "Rent Payment Assistance";
    const encodedURL = encodeURI(
      `${process.env.VUE_APP_V1DIR}proxy/v1/services/complete?query={"$area:like":{"type":"zipcode","name":"${zipcode}","$table.field":[{"service_taxonomy.taxonomy_detail":"${taxTerm}"}]}}&per_page=10`
    );
    const response = await Api.get(encodedURL, {
      headers,
    });
    return response.data;
  }

  async GetServicesByTaxTerm(taxTerm, zipcode, region, baseUrl, page = 1) {
    Api.defaults.withCredentials = true;
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const searchId = this.getSetSearchId(page)
      if (searchId) {
        headers["x-search-id"] = searchId;
      }

    if (region && region !== "undefined" && region !== "null") {
      headers["x-region"] = region;
    }

    if (baseUrl) {
      headers["x-provenance-info"] = baseUrl;
    }

    const cookiesArrayFromSession = JSON.parse(localStorage.getItem(`${window.location.host}`));
    if (cookiesArrayFromSession) {
      headers.Authorization = cookiesArrayFromSession?.join(';');
    }

    const url = `${process.env.VUE_APP_V1DIR}proxy/v1/services?query={"$area:like":{"type":"zipcode","name":"${zipcode}","$table.field":[{"service_taxonomy.taxonomy_detail":"${taxTerm}"}]}}&per_page=100&page=${page}`;
    const encodedURL = encodeURI(url);
    const response = await Api.get(encodedURL, { headers });
    return response.data;
  }

  async ValidateAddress(address) {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const cookiesArrayFromSession = JSON.parse(localStorage.getItem(`${window.location.host}`));
    if (cookiesArrayFromSession) {
      headers.Authorization = cookiesArrayFromSession?.join(';');
    }

    const body = {
      address,
    };

    const url = `https://addressvalidation.googleapis.com/v1:validateAddress?key=AIzaSyACE2hQig1sl9NxBk6BPKaYmIQfYYnYS0s`;
    const response = await Api.post(url, body, headers);
    return response;
  }

  async GetServicesByTaxCode(taxCode, zipcode, region, baseUrl, page = 1) {
    Api.defaults.withCredentials = true;
    const dataName = `services-${taxCode}-${zipcode}-page=${page}`;
    let sessionData = sessionStorage.getItem(dataName);
    if (sessionData && this.isJsonParsable(sessionData)) {
      return JSON.parse(sessionData);
    }
    // if script is run locally use mocked data
    if (isLocal()) {
      this.setSessionStorage(dataName, serviceListMockedData);
      return serviceListMockedData;
    } else {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      const searchId = this.getSetSearchId(page)
      if (searchId) {
        headers["x-search-id"] = searchId;
      }

      if (region && region !== "undefined" && region !== "null") {
        headers["x-region"] = region;
      }

      if (baseUrl) {
        headers["x-provenance-info"] = baseUrl;
      }

      const cookiesArrayFromSession = JSON.parse(localStorage.getItem(`${window.location.host}`));
      if (cookiesArrayFromSession) {
        headers.Authorization = cookiesArrayFromSession?.join(';');
      }

      const url = `${process.env.VUE_APP_V1DIR}proxy/v1/services?query={"$area:like":{"type":"zipcode","name":"${zipcode}","$table.field":[{"service_taxonomy.taxonomy_id":"${taxCode}"}]}}&sort_by={"type":"zipcode","name":"${zipcode}"}&per_page=100&page=${page}`;
      const encodedURL = encodeURI(url);
      const response = await Api.get(encodedURL, { headers });
      this.setSessionStorage(dataName, response.data);
      return response.data;
    }
  }

  async GetAreas(type, page = 1) {
    Api.defaults.withCredentials = true;
    const dataName = `cie-areas-${type}-page=${page}`;
    let sessionData = sessionStorage.getItem(dataName);
    if (sessionData && this.isJsonParsable(sessionData)) {
      return JSON.parse(sessionData);
    }
    // if script is run locally use mocked data
    if (isLocal()) {
      this.setSessionStorage(dataName, areaZipcodeListMockedData);
      return areaZipcodeListMockedData;
    } else {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      const cookiesArrayFromSession = JSON.parse(localStorage.getItem(`${window.location.host}`));
      if (cookiesArrayFromSession) {
        headers.Authorization = cookiesArrayFromSession?.join(';');
      }

      const url = `${process.env.VUE_APP_V1DIR}proxy/v1/services/areas?query={"type":"${type}"}&per_page=2000&page=${page}'`;
      const encodedURL = encodeURI(url);
      const response = await Api.get(encodedURL, { headers });
      this.setSessionStorage(dataName, response.data);
      return response.data;
    }
  }

  async GetServicesByAltName(altName, zipcode, region, baseUrl, page = 1) {
    Api.defaults.withCredentials = true;
    const altNameArray = altName.split(",");

    const dataName = `services-${altNameArray.join(
      "-"
    )}-${zipcode}-page=${page}`;
    const altNamesWithQuotes = `"${altNameArray.join('","')}"`;

    let sessionData = sessionStorage.getItem(dataName);
    if (sessionData && this.isJsonParsable(sessionData)) {
      return JSON.parse(sessionData);
    }
    // if script is run locally use mocked data
    if (isLocal()) {
      this.setSessionStorage(dataName, serviceListMockedData);
      return serviceListMockedData;
    } else {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      if (region && region !== "undefined" && region !== "null") {
        headers["x-region"] = region;
      }

      if (baseUrl) {
        headers["x-provenance-info"] = baseUrl;
      }

      const cookiesArrayFromSession = JSON.parse(localStorage.getItem(`${window.location.host}`));
      if (cookiesArrayFromSession) {
        headers.Authorization = cookiesArrayFromSession?.join(';');
      }

      // zipcode = "49505";
      // taxCode = "PL-7400.1550";
      const url = `${process.env.VUE_APP_V1DIR}proxy/v1/services?query={"$area:like":{"type":"zipcode","name":"${zipcode}"},"alternate_name": {"$in":[${altNamesWithQuotes}]}}&sort_by={"type":"zipcode","name":"${zipcode}"}&per_page=100&page=${page}`;
      const encodedURL = encodeURI(url);
      const response = await Api.get(encodedURL, { headers });
      this.setSessionStorage(dataName, response.data);
      return response.data;
    }
  }

  /**
   *
   * @param {*} query - should include the per_page and sort_by parameters
   * @param {*} region
   * @returns
   */
  async GetServicesByQuery(query, region, baseUrl, page = 1, envUrl) {
    Api.defaults.withCredentials = true;
    const dataName = query.replace(/[^0-9a-z]/gi, "_") + `_page=${page}`;
    let sessionData = sessionStorage.getItem(dataName);
    if (sessionData && this.isJsonParsable(sessionData)) {
      return JSON.parse(sessionData);
    }
    // if script is run locally use mocked data
    if (isLocal()) {
      this.setSessionStorage(dataName, serviceListMockedData);
      return serviceListMockedData;
    } else {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      const searchId = this.getSetSearchId(page)
      if (searchId) {
        headers["x-search-id"] = searchId;
      }

      if (region && region !== "undefined" && region !== "null") {
        headers["x-region"] = region;
      }

      if (baseUrl) {
        headers["x-provenance-info"] = baseUrl;
      }

      const cookiesArrayFromSession = JSON.parse(localStorage.getItem(`${window.location.host}`));
      if (cookiesArrayFromSession) {
        headers.Authorization = cookiesArrayFromSession?.join(';');
      }

      // query should include the per_page and sort_by parameters
      let url = `${process.env.VUE_APP_V1DIR}proxy/v1/services?query=${query}&page=${page}`;

      if(envUrl){
        url = `${envUrl}proxy/directory/services?query=${query}&page=${page}`;
      }

      const encodedURL = encodeURI(url);
      const response = await Api.get(encodedURL, { headers });
      this.setSessionStorage(dataName, response.data);
      return response.data;
    }
  }

  getSetSearchId(page){
    let searchId = null
      if(page === 1){
        const UUID = require('uuid-js');
        const searchId = UUID.create().toString()
        sessionStorage.setItem("searchId", JSON.stringify({id: searchId, epoch: null}));
      }
      return searchId
  }

  /**
 *
 * @param {*} query - should include the per_page and sort_by parameters
 * @param {*} region
 * @returns
 */
  async GetCompleteServicesByQuery(query, region, baseUrl, page = 1, perPage = 10, envUrl, mockType = null) {
    Api.defaults.withCredentials = true;
    const dataName = query.replace(/[^0-9a-z]/gi, "_") + `_page=${page}`;
    let sessionData = sessionStorage.getItem(dataName);
    if (sessionData && this.isJsonParsable(sessionData)) {
      return JSON.parse(sessionData);
    }
    // if script is run locally use mocked data
    if (isLocal()) {
      if(mockType && mockType === 'reccomendedServices'){
        this.setSessionStorage(dataName, mockServiceCompleteReferralData);
        return mockServiceCompleteReferralData;
      }else{
        this.setSessionStorage(dataName, serviceDetailMockedData);
        return serviceDetailMockedData;
      }
    } else {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      if (region && region !== "undefined" && region !== "null") {
        headers["x-region"] = region;
      }

      if (baseUrl) {
        headers["x-provenance-info"] = baseUrl;
      }

      // query should include the per_page and sort_by parameters
      let url = `${process.env.VUE_APP_V1DIR}proxy/v1/services/complete?query=${query}&page=${page}&per_page=${perPage}`;

      if(envUrl){
        url = `${envUrl}proxy/directory/services/complete?query=${query}&page=${page}&per_page=${perPage}`;
      }

      const cookiesArrayFromSession = JSON.parse(localStorage.getItem(`${window.location.host}`));
      if (cookiesArrayFromSession) {
        headers.Authorization = cookiesArrayFromSession?.join(';');
      }

      const encodedURL = encodeURI(url);
      const response = await Api.get(encodedURL, { headers });
      this.setSessionStorage(dataName, response.data);
      return response.data;
    }
  }

  async GetServicesCompleteByID(serviceId, region, baseUrl) {
    Api.defaults.withCredentials = true;
    const dataName = `serviceComplete-${serviceId}`;
    let sessionData = sessionStorage.getItem(dataName);
    if (sessionData && this.isJsonParsable(sessionData)) {
      return JSON.parse(sessionData);
    }

    // if script is run locally use mocked data
    if (isLocal()) {
      this.setSessionStorage(dataName, serviceDetailMockedData);
      return serviceDetailMockedData;
    } else {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      const searchId = this.getValidSearchId()
      if (searchId) {
        headers["x-search-id"] = searchId;
      }

      if (region && region !== "undefined" && region !== "null") {
        headers["x-region"] = region;
      }

      if (baseUrl) {
        headers["x-provenance-info"] = baseUrl;
      }

      const cookiesArrayFromSession = JSON.parse(localStorage.getItem(`${window.location.host}`));
      if (cookiesArrayFromSession) {
        headers.Authorization = cookiesArrayFromSession?.join(';');
      }

      const encodedURL = encodeURI(
        `${process.env.VUE_APP_V1DIR}proxy/v1/services/complete/${serviceId}`
      );
      const response = await Api.get(encodedURL, { headers });
      this.setSessionStorage(dataName, response.data);
      return response.data;
    }
  }

  getValidSearchId(){
      sessionStorage.getItem("searchId");
      const searchId = sessionStorage.getItem('searchId') && JSON.parse(sessionStorage.getItem('searchId'))
      const id = searchId ? searchId.id : null
      const epoch = searchId ? searchId.epoch : null
      const currentEpoch = new Date().getTime()
      if(epoch && currentEpoch - epoch < 10000){
        return id
      }
      return null
  }

  async GetSearchResults(searchText, pageNo, pageSize) {
    Api.defaults.withCredentials = true;
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const cookiesArrayFromSession = JSON.parse(localStorage.getItem(`${window.location.host}`));
      if (cookiesArrayFromSession) {
        headers.Authorization = cookiesArrayFromSession?.join(';');
      }

    // // query should include the per_page and sort_by parameters
    const url = encodeURI(`${process.env.VUE_APP_V1DIR}proxy/discoveryV1/TextSearch?text=${searchText || 'food'}`);
    const response = await Api.get(url, { headers });
    console.log('&&&&&&', response.data.result.data.ResultItems.sort(() => Math.random() - 0.5))
    const responseFromAPI = response.data.result.data.ResultItems.sort(() => Math.random() - 0.5)

    console.log('&&&&&&&&&&&&&&&&&&&&&', responseFromAPI);

    console.log("GetSearchResults", searchText, pageNo, pageSize);
    const result = {
      ...response.data.result.data,
      ResultItems: response.data.result.data.ResultItems.sort(
        () => Math.random() - 0.5
      ),
    };
    console.log('---resultusltul', result)
    return Promise.resolve(result);
  }
}
